export type LocaleCode =
   | 'en-us'
   | 'en-ca'
   | 'en-au'
   | 'en-gb'
   | 'fr-fr'
   | 'de-de'
   | 'it-it'
   | 'en-eu';
export type LanguageCode = 'en' | 'fr' | 'de' | 'it';

export type ProductIndex =
   | 'product_en_us'
   | 'product_en_ca'
   | 'product_en_uk'
   | 'product_en_au'
   | 'product_en_eu'
   | 'product_fr_fr'
   | 'product_de_de'
   | 'product_it_eu';

export const PRODUCT_INDICES_BY_LOCALE: Record<LocaleCode, ProductIndex> = {
   'en-us': 'product_en_us',
   'en-gb': 'product_en_uk',
   'en-au': 'product_en_au',
   'en-ca': 'product_en_ca',
   'en-eu': 'product_en_eu',
   'fr-fr': 'product_fr_fr',
   'de-de': 'product_de_de',
   'it-it': 'product_it_eu',
};

export const LOCALIZED_FACET_MAPPINGS_BY_INDEX = {
   product_en_us: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_ca: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_uk: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_au: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_eu: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_fr_fr: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacité',
      'facet_tags.Item Type': 'facet_tags_localized.type de produit',
      'facet_tags.Part or Kit': 'facet_tags_localized.Pièce ou kit',
      'facet_tags.Tool Category': "facet_tags_localized.Catégorie d'outils",
      'facet_tags.Main Category': 'facet_tags_localized.catégorie principale',
      'worksin': 'worksin',
   },
   product_de_de: {
      'facet_tags.Capacity': 'facet_tags_localized.Kapazität',
      'facet_tags.Item Type': 'facet_tags_localized.Produkttyp',
      'facet_tags.Part or Kit': 'facet_tags_localized.Ersatzteil oder Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Werkzeugtyp',
      'facet_tags.Main Category': 'facet_tags_localized.Hauptkategorie',
      'worksin': 'worksin',
   },
   product_it_eu: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacità',
      'facet_tags.Item Type': 'facet_tags_localized.Tipo di prodotto',
      'facet_tags.Part or Kit': 'facet_tags_localized.Parte o kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Categoria strumenti',
      'facet_tags.Main Category': 'facet_tags_localized.Categoria principale',
      'worksin': 'worksin',
   },
} as const;

export type LocalizedFacetMappings = typeof LOCALIZED_FACET_MAPPINGS_BY_INDEX;
export type FacetKey = keyof LocalizedFacetMappings[ProductIndex];

export function localizedFacetFor({ key, locale }: { key: FacetKey; locale: LocaleCode }) {
   const productIndex = PRODUCT_INDICES_BY_LOCALE[locale];
   return LOCALIZED_FACET_MAPPINGS_BY_INDEX[productIndex][key];
}

export function getLocalizedFacetMappings(
   indexName: keyof typeof LOCALIZED_FACET_MAPPINGS_BY_INDEX
) {
   return LOCALIZED_FACET_MAPPINGS_BY_INDEX[indexName];
}

export function getIsProAlgoliaFilter({
   includeProProducts,
}: { includeProProducts: boolean }): string {
   const nonProUserFilter = 'is_pro <= 0';
   const proUserFilter = 'is_pro >= 0';
   return includeProProducts ? proUserFilter : nonProUserFilter;
}
